import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../types/state';
import { useEffect } from 'react';
import { getJobs } from '../redux/actions/jobs';

const useJobs = () => {
  const { jobs, loading } = useSelector((state: StoreState) => state.jobs);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!jobs && !['loading', 'failed'].includes(loading)) {
      dispatch(getJobs());
    }
  }, [jobs, loading, dispatch]);

  return { jobs, loading };
};

export default useJobs;
